import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../_redux/kurban/kurbanAction";
import * as uiHelpers from "../KurbanUIHelpers";
import { DateColumnFormatter } from "./column-formatters/DateColumnsFormatter";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toastOption,
} from "../../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { useKurbanListUIContext } from "../KurbanUIContext";
import { toast } from "react-toastify";
import { Card, Table } from "react-bootstrap";
import { StatusKurban } from "./column-formatters/StatusKurban";
// import { act } from 'react-dom/test-utils';

export const KurbanListTable = (props) => {
  // KurbanList UI Context
  const kurbanListUIContext = useKurbanListUIContext();
  const kurbanListUIProps = useMemo(() => {
    return {
      queryParams: kurbanListUIContext.queryParams,
      setQueryParams: kurbanListUIContext.setQueryParams,
      newKurbanListClick: kurbanListUIContext.newKurbanListClick,
      openDetailKurbanListPage: kurbanListUIContext.openDetailKurbanListPage,
      openChooseKurbanListPage: kurbanListUIContext.openChooseKurbanListPage,
      openMergingDetail: kurbanListUIContext.openMergingDetail,
      openKurbanDetail: kurbanListUIContext.openKurbanDetail,
    };
  }, [kurbanListUIContext]);

  // Getting curret state of branch list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.kurbanList }),
    shallowEqual
  );

  const { listLoading, entities, totalCount } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Donatur Action
    dispatch(actions.fetchKurbanTableList(kurbanListUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, kurbanListUIProps.queryParams]);

  // console.log(kurbanListUIProps.openDetailKurbanListPage)

  // Table columns
  const columns = [
    {
      dataField: "donation.donation_hid",
      text: "ID Donasi",
    },
    {
      dataField: "thk_kurban.kurban_hid",
      text: "ID Kurban",
    },
    {
      dataField: "thk_livestock.type",
      text: "Tipe Hewan",
      formatter: (cell, row) => {
        const type = uiHelpers.TIPE_HEWAN_HELPER.find(
          (item) => item.value == cell
        );
        return <span>{type.text}</span>;
      },
    },
    {
      dataField: "thk_livestock_campaign.name",
      text: "Kategori Hewan",
    },
    {
      dataField: "thk_livestock.name",
      text: "Nama Hewan",
      // formatter: columnFormatters.StatusColumnFormatter
    },
    {
      text: "Status Distribusi",
      formatter: (cell, row) => {
        return (
          <>
            {row.thk_kurban_uuid ? (
              <span className={`label label-lg label-light-info label-inline`}>
                TERDISTRIBUSI
              </span>
            ) : (
              <span
                className={`label label-lg label-light-warning label-inline`}
              >
                BELUM TERDISTRIBUSI
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "thk_kurban.status",
      text: "Status Kurban",
      formatter: (cell, row) => {
        if (row.thk_kurban_uuid) {
          return StatusKurban(cell);
        }
      },
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openDetailKurbanListPage: kurbanListUIProps.openDetailKurbanListPage,
        openMergingDetail: kurbanListUIProps.openMergingDetail,
        openKurbanDetail: kurbanListUIProps.openKurbanDetail,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  //   * Expand Row
  const expandRow = {
    renderer: (row) => {
      const kurbanPhotos = () => {
        if (
          row.thk_kurban &&
          row.thk_kurban.after_photo_uuid &&
          row.thk_kurban.before_photo_uuid
        ) {
          const beforeImage = `${row.thk_kurban.before_photo.storage}/${row.thk_kurban.before_photo.path}`;
          const afterImage = `${row.thk_kurban.after_photo.storage}/${row.thk_kurban.after_photo.path}`;
          return (
            <>
              <div className="row mb-4">
                <div className="col">
                  <Card>
                    <Card.Body>
                      <Card.Title>Foto Sebelum</Card.Title>
                    </Card.Body>
                    <Card.Img variant="top" src={beforeImage} width="100%" />
                  </Card>
                </div>
                <div className="col">
                  <Card>
                    <Card.Body>
                      <Card.Title>Foto Sesudah</Card.Title>
                    </Card.Body>
                    <Card.Img variant="top" src={afterImage} width="100%" />
                  </Card>
                </div>
              </div>
            </>
          );
        }
      };
      return (
        <div>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th className="text-center" colSpan={7}>
                  Atas Nama
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center">1</td>
                <td className="text-center">2</td>
                <td className="text-center">3</td>
                <td className="text-center">4</td>
                <td className="text-center">5</td>
                <td className="text-center">6</td>
                <td className="text-center">7</td>
              </tr>
              <tr>
                <td>{row.name_1}</td>
                <td>{row.name_2}</td>
                <td>{row.name_3}</td>
                <td>{row.name_4}</td>
                <td>{row.name_5}</td>
                <td>{row.name_6}</td>
                <td>{row.name_7}</td>
              </tr>
            </tbody>
          </Table>
          <table width={"100%"}>
            <tbody>
              <tr>
                <td width="140px">
                  <p>
                    <b>Nama Mitra</b>
                  </p>
                </td>
                <td width="5%">:</td>
                <td>
                  <p>
                    <b>
                      {row.thk_kurban &&
                        row.thk_kurban.thk_partner &&
                        row.thk_kurban.thk_partner.name}
                    </b>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <b>Hasli Merging</b>
                  </p>
                </td>
                <td>:</td>
                <td>
                  <p>
                    <b>
                      {row.thk_kurban && row.thk_kurban.is_merging
                        ? "Ya"
                        : "Tidak"}
                    </b>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          {kurbanPhotos()}
        </div>
      );
    },
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return (
          <i
            style={{ cursor: "pointer" }}
            class="fas fa-caret-down fa-rotate-180"
          ></i>
        );
      }
      return <i style={{ cursor: "pointer" }} class="fas fa-caret-down"></i>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <i
            style={{ cursor: "pointer" }}
            class="fas fa-caret-down fa-rotate-180"
          ></i>
        );
      }
      return <i style={{ cursor: "pointer" }} class="fas fa-caret-down"></i>;
    },
    showExpandColumn: true,
  };

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: kurbanListUIProps.queryParams.pageSize,
    page: kurbanListUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden hover"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  kurbanListUIProps.setQueryParams
                )}
                expandRow={expandRow}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};
